import React from 'react';
import PropTypes from 'prop-types';
import Link from '@fogia/core-web/components/Link';
import styled from 'libs/styled';
import ChevronLeft from 'assets/media/icons/ChevronLeft';
import ChevronRight from 'assets/media/icons/ChevronRight';

const StyledButton = styled('button')`
    display: flex;
    height: 30px;
    width: 30px;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    pointer-events: none;

    &[data-is-active='true'] {
        pointer-events: auto;
    }

    &[data-is-active='false'] {
        opacity: 0.3;
    }
`;

const PaginationButton = ({ direction, to, active, ...rest }) => {
    const Icon = direction === 'left' ? ChevronLeft : ChevronRight;

    return (
        <StyledButton as={to ? Link : 'button'} to={to} data-is-active={active} {...rest}>
            <Icon color="currentColor" />
        </StyledButton>
    );
};

PaginationButton.propTypes = {
    active: PropTypes.bool,
    direction: PropTypes.string,
    to: PropTypes.string,
};

PaginationButton.defaultProps = {
    active: false,
    direction: 'left',
    to: null,
};

export default PaginationButton;
